<ng-template #mobile>
  <div class="mobile-title">
    <app-mobile-page-back-header iconUrl="{{licenceService.getKey('icon-menu-change-password')}}"><ng-container i18n>{{page?.header}}</ng-container></app-mobile-page-back-header>
  </div>
</ng-template>

<div class="page-body desktop-panel" [ngClass]="isDesktop ? 'desktop': 'mobile'">

  <div *ngIf="isDesktop else mobile" class="change-password-title">
    <div class="title">
      <img src="{{licenceService.getKey('icon-menu-change-password')}}" alt="icon-edit-profile">
      <h2 i18n>{{page?.header}}</h2>
    </div>
    <div class="icon-close">
      <a [routerLink]="['', 'client-area', 'main']">
        <app-close-dialog-button [customClass]="'large'" [position]="true"></app-close-dialog-button>
      </a>
    </div>
  </div>

  <div class="change-password-img">
    <img src="{{licenceService.getKey('change-password-img')}}" alt="image-pass-code-modal">
  </div>

  <div class="change-password-cms-text" [innerHTML]="body"></div>

  <div *ngIf="!isSuccess else completed" class="casino-form-wrapper desktop-panel" fxLayout="row" fxLayoutAlign="center center">
    <div id="casino-form" class="">
      <div *ngIf="hasError" class="submit-error">{{errorMsg}}</div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <form name="changePasswordForm" class="form-custom-design" [formGroup]="changePasswordForm" (ngSubmit)="onSubmit(changePasswordForm)">
          <mat-form-field class="password" appearance="outline">
            <mat-label i18n>old password</mat-label>
            <input matInput [type]="hideOldPassword ? 'password' : 'text'" formControlName="old_password">
            <img class="img-suffix" src="assets/playbison/login/{{hideOldPassword ? 'icon-eyedisabled' : 'icon-eye'}}.svg" matSuffix (click)="hideOldPassword = !hideOldPassword">
            <mat-error *ngIf="changePasswordForm.get('old_password')?.hasError('required')" i18n>Please enter old password.</mat-error>
            <mat-error *ngIf="changePasswordForm.get('old_password')?.hasError('minlength')" i18n>Your password is too short.</mat-error>
          </mat-form-field>
          <mat-form-field class="password" appearance="outline">
            <mat-label i18n>new password</mat-label>
            <input matInput [type]="hideNewPassword ? 'password' : 'text'" formControlName="new_password">
            <img class="img-suffix" src="assets/playbison/login/{{hideNewPassword ? 'icon-eyedisabled' : 'icon-eye'}}.svg" matSuffix (click)="hideNewPassword = !hideNewPassword">
            <mat-error *ngIf="changePasswordForm.get('new_password')?.hasError('required')" i18n>Please enter new password.</mat-error>
            <mat-error *ngIf="changePasswordForm.get('new_password')?.hasError('minlength')" i18n>Your password is too short.</mat-error>
          </mat-form-field>
          <mat-form-field class="password" appearance="outline">
            <mat-label i18n>Repeat new password</mat-label>
            <input matInput [type]="hideRepeatPassword ? 'password' : 'text'" formControlName="new_password_repeat">
            <img class="img-suffix" src="assets/playbison/login/{{hideRepeatPassword ? 'icon-eyedisabled' : 'icon-eye'}}.svg" matSuffix (click)="hideRepeatPassword = !hideRepeatPassword">
            <mat-error *ngIf="changePasswordForm.get('new_password_repeat')?.hasError('required')" i18n>Please enter your password.</mat-error>
            <mat-error *ngIf="changePasswordForm.get('new_password_repeat')?.hasError('minlength')" i18n>Your password is too short.</mat-error>
          </mat-form-field>
          <div class="buttons">
            <div><button round-button filled="filled" color="accent" type="submit" [disabled]="!changePasswordForm.valid" i18n>submit</button></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<ng-template #completed>
  <div class="result" fxLayout="row" fxLayoutAlign="center center" i18n>Your password has successfully been changed.</div>
</ng-template>
<router-outlet></router-outlet>